export default {
  lang: '',
  userName: '',
  userIsLogin: false,
  userFulled: null,
  showSetting: false,
  userProjectCount: 0,
  isShowCommonModule: false,
  privacyPolicyUrl: 'javascript:;',
  primiorLinkUrl: 'javascript:;',
  termsofService: 'javascript:;',
  primiorRatingPdf: 'javascript:;'
};
